var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLangEs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_305_37",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 22
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 11.2856,
    cy: 11,
    r: 11,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_305_37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-3.13384 0C-4.52259 0 -5.64832 1.12573 -5.64832 2.51447V19.4826C-5.64832 20.8713 -4.52259 21.9971 -3.13384 21.9971H5.54317V0H-3.13384Z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7348 0.000488281H5.54309V21.9976H16.7348V0.000488281Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.4116 0H16.7346V21.997H25.4116C26.8003 21.997 27.9261 20.8713 27.9261 19.4825V2.51447C27.9261 1.12573 26.8004 0 25.4116 0Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.1372 11.5161L11.1388 12.0153V12.5146H11.638L12.1372 11.5161Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.1388 13.7632C11.0008 13.7632 10.8892 13.6516 10.8892 13.5136V12.5153C10.8892 12.3773 11.0008 12.2656 11.1388 12.2656C11.2768 12.2656 11.3884 12.3773 11.3884 12.5153V13.5136C11.3884 13.6516 11.2768 13.7632 11.1388 13.7632Z",
    fill: "#00C3A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.1388 12.7645C10.1584 12.7645 9.21173 12.3862 8.47296 11.6993C8.37204 11.6055 8.36621 11.4475 8.46011 11.3467C8.55467 11.246 8.71244 11.2406 8.81284 11.3337C9.45902 11.9346 10.2851 12.2653 11.139 12.2653C11.9928 12.2653 12.8189 11.9346 13.4651 11.3337C13.5658 11.2404 13.7235 11.2455 13.8178 11.3467C13.9116 11.4476 13.9058 11.6055 13.8049 11.6993C13.066 12.3862 12.1193 12.7645 11.1388 12.7645Z",
    fill: "#00C3A0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.1387 13.7629C10.4989 13.7629 9.87905 13.5759 9.34619 13.222L9.62259 12.8062C10.5235 13.4048 11.754 13.4048 12.6548 12.8062L12.9312 13.222C12.3984 13.5759 11.7786 13.7629 11.1387 13.7629Z",
    fill: "#00AADC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.7438 10.3931L10.1926 11.2459L10.099 11.5267L11.5342 11.1939L10.7438 10.3931Z",
    fill: "#732D37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.61115 11.8009C8.95134 11.8009 8.15932 11.2456 7.94922 10.0083L8.44162 9.92496C8.61618 10.9538 9.24924 11.3024 9.62918 11.3014C9.74571 11.2982 9.86729 11.258 9.87686 11.1757C9.88807 11.0772 9.89076 11.0538 9.62971 10.9656C9.48781 10.9175 9.32695 10.8632 9.21409 10.734C8.7575 10.2126 9.37567 9.66083 9.67266 9.39564C9.72506 9.34882 9.74676 9.30908 9.74119 9.294C9.72486 9.25131 9.62689 9.18678 9.51646 9.18678C9.19934 9.18678 8.95875 9.00763 8.88884 8.7195C8.81619 8.42113 8.95343 8.1067 9.21475 7.97168L9.44394 8.41529C9.38269 8.44697 9.35843 8.53713 9.37397 8.60153C9.38007 8.62736 9.39495 8.68756 9.51659 8.68756C9.82224 8.68756 10.1131 8.86796 10.2076 9.11609C10.2481 9.22187 10.309 9.49682 10.0053 9.76811C9.67745 10.0609 9.48125 10.2812 9.58997 10.4053C9.61456 10.4333 9.72014 10.4692 9.78984 10.4926C10.0146 10.5686 10.4329 10.71 10.3729 11.2329C10.3354 11.5616 10.0419 11.7898 9.64315 11.8006C9.63233 11.8006 9.62158 11.8009 9.61115 11.8009Z",
    fill: "#AAD264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.638 9.02045C11.638 9.02045 12.1372 8.02207 11.1388 7.52285C11.1388 7.52285 14.6332 7.02363 14.134 11.5166L14.1338 11.5164C13.8062 11.2543 13.3198 10.7752 13.146 10.3933L11.638 9.51967V9.02045Z",
    fill: "#874150"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.1388 10.0186L13.6348 11.5162C13.6348 11.5162 13.6348 11.5162 12.6364 12.0154L11.1388 10.5178V10.0186Z",
    fill: "#732D37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.1406 8.52106C10.4163 8.52106 10.6398 8.74461 10.6398 9.02029L10.6393 9.02088C10.3415 9.31872 10.2677 9.77361 10.456 10.1503L10.5688 10.376C10.6158 10.47 10.6778 10.5559 10.7521 10.6303L12.1374 12.0157V11.3258C12.1374 10.4663 11.9373 9.61859 11.553 8.84986C11.2993 8.3425 10.7807 8.02197 10.2135 8.02197H10.1406V8.52106Z",
    fill: "#783C46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.1405 8.02197L9.64124 8.52119V9.02042C9.64124 9.02042 10.2351 8.71936 10.4352 8.62343C10.5751 8.55641 10.5496 8.39791 10.4694 8.32152C10.4069 8.26211 10.1405 8.02197 10.1405 8.02197Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M11.1387 14.7613C8.79895 14.7613 6.89551 12.8578 6.89551 10.5181H7.39473C7.39473 12.5827 9.07417 14.2621 11.1388 14.2621C13.2034 14.2621 14.8829 12.5827 14.8829 10.5181H15.3821C15.382 12.8578 13.4785 14.7613 11.1387 14.7613Z",
    fill: "#AAD264"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M7.42201 12.3382C7.6091 12.3382 7.76077 12.1865 7.76077 11.9994C7.76077 11.8123 7.6091 11.6606 7.42201 11.6606C7.23492 11.6606 7.08325 11.8123 7.08325 11.9994C7.08325 12.1865 7.23492 12.3382 7.42201 12.3382Z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M8.17079 13.5345C8.35788 13.5345 8.50955 13.3828 8.50955 13.1957C8.50955 13.0086 8.35788 12.8569 8.17079 12.8569C7.9837 12.8569 7.83203 13.0086 7.83203 13.1957C7.83203 13.3828 7.9837 13.5345 8.17079 13.5345Z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M9.38722 14.4388C9.57431 14.4388 9.72598 14.2871 9.72598 14.1C9.72598 13.9129 9.57431 13.7612 9.38722 13.7612C9.20013 13.7612 9.04846 13.9129 9.04846 14.1C9.04846 14.2871 9.20013 14.4388 9.38722 14.4388Z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M14.8916 12.3382C15.0787 12.3382 15.2304 12.1865 15.2304 11.9994C15.2304 11.8123 15.0787 11.6606 14.8916 11.6606C14.7045 11.6606 14.5529 11.8123 14.5529 11.9994C14.5529 12.1865 14.7045 12.3382 14.8916 12.3382Z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M14.142 13.5345C14.3291 13.5345 14.4807 13.3828 14.4807 13.1957C14.4807 13.0086 14.3291 12.8569 14.142 12.8569C13.9549 12.8569 13.8032 13.0086 13.8032 13.1957C13.8032 13.3828 13.9549 13.5345 14.142 13.5345Z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.9254 14.4388C13.1125 14.4388 13.2642 14.2871 13.2642 14.1C13.2642 13.9129 13.1125 13.7612 12.9254 13.7612C12.7383 13.7612 12.5867 13.9129 12.5867 14.1C12.5867 14.2871 12.7383 14.4388 12.9254 14.4388Z",
    fill: "#FFE15A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M11.3886 14.0126H10.8894C10.6137 14.0126 10.3901 13.7891 10.3901 13.5134C10.3901 13.2377 10.6137 13.0142 10.8894 13.0142H11.3886C11.6643 13.0142 11.8878 13.2377 11.8878 13.5134C11.8879 13.7891 11.6643 14.0126 11.3886 14.0126Z",
    fill: "#FFB478"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M13.146 10.3932C13.3125 10.882 13.666 11.3292 14.1338 11.5162L14.134 11.5164C14.6332 7.02363 11.1388 7.52285 11.1388 7.52285C13.6348 7.52285 13.146 10.3932 13.146 10.3932Z",
    fill: "#9B4B5A"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEs);
export default __webpack_public_path__ + "static/media/lang-es.2295acf32a9975a077dee8df188cadb2.svg";
export { ForwardRef as ReactComponent };